// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"5915809d","453":"d9fae86c","648":"8dffbc2d"}[chunkId] + ".chunk.js";
};